module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="pz-login login-page">\n    <div class="row">\n        <div class="logo col-md-4 col-md-offset-4">Pazien</div>\n    </div>\n    <div class="row">\n        <div class="col-sm-' +
((__t = ( data.stretch ? 12 : 6 )) == null ? '' : __t) +
' col-sm-offset-' +
((__t = ( data.stretch ? 0 : 3 )) == null ? '' : __t) +
' col-md-' +
((__t = ( data.stretch ? 6 : 4 )) == null ? '' : __t) +
' col-md-offset-' +
((__t = ( data.stretch ? 3 : 4 )) == null ? '' : __t) +
' merchant-login">\n            <div class="' +
((__t = ( data.stretch ? '' : 'row' )) == null ? '' : __t) +
'">\n                <div class="' +
((__t = ( data.stretch ? '' : 'col-md-10 col-md-offset-1' )) == null ? '' : __t) +
' login-area">\n                    ' +
((__t = ( data.partial(data) )) == null ? '' : __t) +
'\n                </div>\n            </div>\n            ';
 if (data.api) { ;
__p += '\n            <div class="debug-info">API: ' +
((__t = ( data.api )) == null ? '' : __t) +
'</div>\n            ';
 } ;
__p += '\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-md-4 col-md-offset-4 spacer text-center copyright"><small>' +
((__t = ( strings.login.copyright )) == null ? '' : __t) +
'</small></div>\n    </div>\n</div>\n';
return __p
}